export const BLANK_MAC_VALUE = "____________";


// WEBPACK FOOTER //
// ./src/constant/appConstants.js